export default __webpack_public_path__ + "static/media/nillkin-case.39a022bd.webp";